import { api, viacep } from '@/api'
import statesList from '@/utils/enums/states'
import checkColorTheme from '@/utils/checkColorTheme'

const actions = {
  pixel: async ({ state, commit }) => {
    const response = await api.post('api/v1/step/pixel', {
      cart: state.cart.hash,
    })

    await commit('SET_PIXELS', response.data)
  },

  identify: async ({ state, commit }, { dataIdentify, vue }) => {
    commit('SET_STATUS_GLOBAL_LOADING', true)
    commit('SET_STATUS_CART_LOADING', true)
    const dataIndentifyCart = {
      ...dataIdentify,
      cart: state.cart.hash,
    }

    const {
      data: { data: fetchIdentify },
    } = await api
      .post('api/v1/step/identify', dataIndentifyCart)
      .finally(() => {
        commit('SET_STATUS_CART_LOADING', false)
        commit('SET_STATUS_GLOBAL_LOADING', false)
      })
      .catch(() => {
        vue.$AmAlert({
          type: 'error',
          description: this.$t('steps.cardFetchErr'),
          autoHide: true,
        })
      })
    await commit('SET_STEPSDATA', dataIndentifyCart)
    await commit('SET_CUSTOMER', fetchIdentify)
    const { id, email, full_name, national_number, telephone, country_code } = fetchIdentify
    await commit(
      'Customer/SET_CUSTOMER',
      { id, email, full_name, national_number, telephone, country_code },
      { root: true }
    )

    return fetchIdentify
  },

  shipping: async ({ state, commit }, dataShipping) => {
    commit('SET_STATUS_GLOBAL_LOADING', true)
    commit('SET_STATUS_CART_LOADING', true)

    const sendData = {
      ...dataShipping,
    }

    if (state.customer?.id) {
      sendData.customer_id = state.customer.id
    }
    if (state.cart?.hash) {
      sendData.cart = state.cart.hash
    }

    commit('SET_STEPSDATA', sendData)
    const { data: fetchShipping } = await api.post('api/v1/step/shipping', sendData).finally(() => {
      commit('SET_STATUS_CART_LOADING', false)
      commit('SET_STATUS_GLOBAL_LOADING', false)
    })

    const {
      postcode,
      address_city,
      address_street,
      address_street_number,
      address_street_district,
      address_street_complement,
      address_state,
    } = fetchShipping

    commit(
      'Customer/SET_CUSTUMER',
      {
        postcode,
        address_city,
        address_street,
        address_street_number,
        address_street_district,
        address_street_complement,
        address_state,
      },
      { root: true }
    )
  },

  paymentBillet: async ({ state, commit }, dataBillet) => {
    try {
      commit('SET_STATUS_GLOBAL_LOADING', true)
      const sendData = {
        ...dataBillet,
        order_id: state.order_id,
        cart: state.cart.hash,
      }

      const {
        data: { data: billetData },
      } = await api.post('api/v1/step/payment/billet', sendData)

      state.cart.payment = billetData
      commit('SET_PAYMENT_BILLET', billetData)
      return true
    } catch (error) {
      throw new Error(error.response.status)
    } finally {
      commit('SET_STATUS_GLOBAL_LOADING', false)
    }
  },

  paymentBilletShopify: async ({ state, commit }, dataBillet) => {
    try {
      commit('SET_STATUS_GLOBAL_LOADING', true)
      const sendData = {
        ...dataBillet,
        order_id: state.order_id,
        cart: state.cart.hash,
      }

      const postBillet = await api.post('api/v1/step/payment/billet-shopify', sendData)
      return postBillet
    } catch (error) {
      throw new Error(error.response.status)
    } finally {
      commit('SET_STATUS_GLOBAL_LOADING', false)
    }
  },

  paymentCreditCard: async ({ state, commit }, dataCreditCard) => {
    try {
      commit('SET_STATUS_GLOBAL_LOADING', true)
      const sendData = {
        ...dataCreditCard,
        order_id: state.order_id,
        cart: state.cart.hash,
      }

      const {
        data: { data: postCreditCard },
      } = await api.post('api/v1/step/payment/pix', sendData)

      state.cart.payment = postCreditCard
      await commit('SET_UPSELL_HASH', postCreditCard.data.data.upsell_hash)

      return postCreditCard
    } catch (error) {
      throw new Error(error.response.status)
    } finally {
      commit('SET_STATUS_GLOBAL_LOADING', false)
    }
  },

  paymentCreditCardShopify: async ({ state, commit }, dataCreditCard) => {
    try {
      commit('SET_STATUS_GLOBAL_LOADING', true)

      if (!dataCreditCard.document) {
        delete dataCreditCard.document
      }

      const sendData = {
        ...dataCreditCard,
        order_id: state.order_id,
        cart: state.cart.hash,
      }

      const postCreditCard = await api.post('api/v1/step/payment/credit-card-shopify', sendData)
      return postCreditCard
    } catch (error) {
      throw new Error(error)
    } finally {
      commit('SET_STATUS_GLOBAL_LOADING', false)
    }
  },

  paymentPix: async ({ state, commit }, dataPix) => {
    try {
      commit('SET_STATUS_GLOBAL_LOADING', true)
      const sendData = {
        ...dataPix,
        order_id: state.order_id,
        cart: state.cart.hash,
      }
      const {
        data: { data: pix },
      } = await api.post('api/v1/step/payment/pix', sendData)

      state.cart.payment = pix
      commit('SET_PAYMENT_PIX', pix)
      return true
    } catch (error) {
      throw new Error(error.response.status)
    } finally {
      commit('SET_STATUS_GLOBAL_LOADING', false)
    }
  },

  paymentPixShopify: async ({ state, commit }, dataPix) => {
    try {
      commit('SET_STATUS_GLOBAL_LOADING', true)
      const sendData = {
        ...dataPix,
        order_id: state.order_id,
        cart: state.cart.hash,
      }
      const postPix = await api.post('api/v1/step/payment/pix-shopify', sendData)
      return postPix
    } catch (error) {
      throw new Error(error.response.status)
    } finally {
      commit('SET_STATUS_GLOBAL_LOADING', false)
    }
  },

  createOrder: async ({ state, dispatch, commit }, paymentType) => {
    try {
      commit('SET_STATUS_GLOBAL_LOADING', true)
      const orderData = {
        payment_method: paymentType,
        cart: state.cart.hash,
      }

      const order = await api.post('api/v1/step/order/create', orderData)
      await dispatch('fetchCart', state.cart.hash)
      return order
    } catch (error) {
      throw Error(error.response.status)
    } finally {
      commit('SET_STATUS_GLOBAL_LOADING', false)
    }
  },

  createUpsell: async ({ state, commit }, upsellId) => {
    try {
      commit('SET_STATUS_GLOBAL_LOADING', true)

      const data = {
        upsell_hash: state.upsell_hash,
        bundle_id: upsellId,
        cart: state.cart.hash,
      }

      const upsell = await api.post('api/v1/step/cart/upsell', data)
      return upsell
    } catch (error) {
      throw Error(error.response.error)
    } finally {
      commit('SET_STATUS_GLOBAL_LOADING', false)
    }
  },

  createOrderShopify: async ({ state, dispatch, commit }, data) => {
    try {
      commit('SET_STATUS_GLOBAL_LOADING', true)
      const orderData = {
        payment_method: data.paymentType,
        telephone: data.telephone,
        email: data.email,
        cart: state.cart.hash,
      }

      const order = await api.post('api/v1/step/order/create-shopify', orderData)
      await dispatch('fetchCart', state.cart.hash)
      return order
    } catch (error) {
      throw Error(error.response.status)
    } finally {
      commit('SET_STATUS_GLOBAL_LOADING', false)
    }
  },

  fetchCart: async ({ commit }, cartId) => {
    try {
      commit('SET_STATUS_CART_LOADING', true)
      const cartData = {
        cart: cartId,
      }
      const {
        data: { data: cart },
      } = await api.post('api/v1/step/cart', cartData)
      commit('SET_CART', cart)
      commit('Customer/SET_CUSTOMER', cart.customer, { root: true })
      commit('SET_COLOR_THEME', checkColorTheme(cart.settings.color))
      commit('SET_IMAGE', cart.settings.image)
      return cart
    } catch (error) {
      throw Error(error)
    } finally {
      commit('SET_STATUS_CART_LOADING', false)
    }
  },

  fetchCartShopify: async ({ commit }, cartId) => {
    try {
      commit('SET_STATUS_CART_LOADING', true)

      const cartData = {
        cart: cartId,
        shopify: true,
      }
      const {
        data: { data: cart },
      } = await api.post('api/v1/step/cart', cartData)
      commit('SET_CART', cart)
      commit('Cart/SET_CART', cart, { root: true })
      commit('SET_COLOR_THEME', checkColorTheme(cart.settings.color))
      commit('SET_IMAGE', cart.settings.image)
      return cart
    } catch (error) {
      throw Error(error)
    } finally {
      commit('SET_STATUS_CART_LOADING', false)
    }
  },

  updateBundle: async ({ state, dispatch, commit }, bundle) => {
    try {
      commit('SET_STATUS_CART_LOADING', true)

      const bundleData = {
        ...bundle,
        cart: state.cart.hash,
      }
      const updateDataBundle = await api.post('/api/v1/step/cart/bundle/update', bundleData)
      await dispatch('Cart/fetchCart', state.cart.hash, { root: true })
      return updateDataBundle
    } catch (error) {
      throw Error(error)
    }
  },

  removeBundle: async ({ state, dispatch, commit }, bundle) => {
    try {
      commit('SET_STATUS_CART_LOADING', true)

      const bundleData = {
        ...bundle,
        cart: state.cart.hash,
      }
      const removeDataBundle = await api.post('/api/v1/step/cart/bundle/remove', bundleData)
      await dispatch('Cart/fetchCart', state.cart.hash, { root: true })
      return removeDataBundle
    } catch (error) {
      throw Error(error)
    } finally {
      await dispatch('Cart/fetchCart', state.cart.hash)
      commit('SET_STATUS_CART_LOADING', false)
    }
  },

  checkPixPaid: async ({ state, commit }, orderId) => {
    try {
      commit('SET_STATUS_CART_LOADING', true)

      const pixData = {
        cart: state.cart.hash,
        order_id: orderId,
      }
      const {
        data: {
          data: { is_paid },
        },
      } = await api.post('/api/v1/step/payment/status', pixData)
      return is_paid
    } catch (error) {
      throw Error(error)
    } finally {
      commit('SET_STATUS_CART_LOADING', false)
    }
  },

  applyerCoupon: async ({ state, dispatch, commit }, couponCode) => {
    try {
      commit('SET_STATUS_CART_LOADING', true)

      const couponData = {
        coupon_code: couponCode,
        cart: state.cart.hash,
      }
      const applyerDataCoupon = await api.post('/api/v1/step/cart/coupon/add', couponData)
      await dispatch('Cart/fetchCart', state.cart.hash, { root: true })
      return applyerDataCoupon
    } catch (error) {
      throw Error(error.response.status)
    } finally {
      await dispatch('Cart/fetchCart', state.cart.hash, { root: true })
      commit('SET_STATUS_CART_LOADING', false)
    }
  },

  removeCoupon: async ({ state, dispatch, commit }, couponCode) => {
    try {
      commit('SET_STATUS_CART_LOADING', true)

      const couponData = {
        coupon_code: couponCode,
        cart: state.cart.hash,
      }
      const removeDataCoupon = await api.post('/api/v1/step/cart/coupon/remove', couponData)
      await dispatch('Cart/fetchCart', state.cart.hash, { root: true })
      return removeDataCoupon
    } catch (error) {
      throw Error(error)
    } finally {
      await dispatch('Cart/fetchCart', state.cart.hash, { root: true })
      commit('SET_STATUS_CART_LOADING', false)
    }
  },

  addFreight: async ({ state, commit }, freight) => {
    try {
      commit('SET_STATUS_CART_LOADING', true)

      const freightData = {
        freight_id: freight,
        cart: state.cart.hash,
      }
      return await api.post('api/v1/step/cart/freight/add', freightData)
    } catch (error) {
      throw Error(error)
    } finally {
      commit('SET_STATUS_CART_LOADING', false)
    }
  },

  addOrderBump: async ({ state, dispatch, commit }, orderBumpId) => {
    try {
      commit('SET_STATUS_CART_LOADING', true)

      const orderBumpData = {
        bundle_id: orderBumpId,
        cart: state.cart.hash,
      }
      const removeDataOrderBumpData = await api.post(
        '/api/v1/step/cart/order-bump/add',
        orderBumpData
      )
      await dispatch('fetchCart', state.cart.hash)
      return removeDataOrderBumpData
    } catch (error) {
      throw Error(error)
    } finally {
      await dispatch('fetchCart', state.cart.hash)
      commit('SET_STATUS_CART_LOADING', false)
    }
  },

  fetchCep: async (_, cep) => {
    const cepData = await viacep
      .get(`/${cep}/json`)
      .then(({ data }) => {
        return data
      })
      .catch(({ response }) => {
        return response.data
      })
    return cepData
  },

  states: async ({ commit }) => {
    const mapStates = statesList.map((state) => {
      return {
        id: state,
        label: state,
      }
    })

    await commit('SET_STATES', mapStates)
  },
}

export default actions
